export default (el, _binding, vnode) => {
    if (_binding.value !== undefined && !_binding.value) return

    const selectionStart = el.selectionStart - 1

    let value

    const removeSpace = value => value.replace('  ', ' ')

    if (el.tagName.toUpperCase() !== 'INPUT') {
        let input = el.getElementsByTagName('input')

        if (input.length !== 1) throw new Error('v-trim directive requires input')
        else el = input[0]

        value = removeSpace(vnode.componentInstance.value)
    } else {
        value = removeSpace(vnode.elm.value)
    }

    if (el.value !== value) {
        el.value = value

        el.dispatchEvent(new Event('input'))
        el.setSelectionRange(selectionStart, selectionStart)
    }
}